import { useEffect, useRef } from 'react';
export default function useFinancialRefresh(callback) {
  const latest = useRef(callback);
  latest.current = callback;
  useEffect(() => {
    let timer;
    const refresh = () => { clearTimeout(timer); timer = setTimeout(() => latest.current(),150); };
    window.addEventListener('erp:financial-changed',refresh);
    window.addEventListener('focus',refresh);
    const channel = typeof BroadcastChannel === 'function' ? new BroadcastChannel('erp-financial') : null;
    if(channel) channel.onmessage=refresh;
    return () => { clearTimeout(timer); window.removeEventListener('erp:financial-changed',refresh); window.removeEventListener('focus',refresh); channel?.close(); };
  },[]);
}
